import { IVideoStream } from '@src/types';
import { useEffect, useRef, useState } from 'react';

const ITEM_HEIGHT = 132;
const ITEM_HORIZONTAL_WIDTH = 272;

export const useVideoSidebar = ({ videos, isVertical }: { videos: IVideoStream[]; isVertical?: boolean }) => {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [visibleCount, setVisibleCount] = useState(3);
  const [startIndex, setStartIndex] = useState(0);

  useEffect(() => {
    const calculateVisibleCount = () => {
      const height = containerRef.current?.offsetHeight || 0;
      const width = containerRef.current?.offsetWidth || 0;
      if (isVertical) {
        setVisibleCount(Math.floor((height - 40) / (ITEM_HEIGHT + 20)));
      } else {
        setVisibleCount(Math.floor((width - 40) / (ITEM_HORIZONTAL_WIDTH + 20)));
      }
    };
    calculateVisibleCount();
    window.addEventListener('resize', calculateVisibleCount);
    return () => window.removeEventListener('resize', calculateVisibleCount);
  }, []);

  const handleUp = () => {
    setStartIndex((prev) => Math.max(prev - visibleCount, 0));
  };

  const handleDown = () => {
    setStartIndex((prev) => prev + visibleCount);
  };

  const visibleVideos = videos.slice(startIndex, startIndex + visibleCount);

  return {
    containerRef,
    handleUp,
    handleDown,
    visibleVideos,
    startIndex,
    visibleCount,
    ITEM_HEIGHT,
    ITEM_HORIZONTAL_WIDTH,
  };
};
